import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DashboardLayout from "../../UI/Layout/DashboardLayout";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { NODE_HOST_URL, RCSAPI } from "../api/Api";
import Dialog from "react-dialog";
import { userId } from "../../Utils/userAuth";
import Axios from "../../../axios/Axios";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import rcsimage from "../assets/img/output-onlinepngtools.png";
import { handleUserLog } from "../../Utils/Utils";

const RcsTemplateList = () => {
  const history = useHistory();

  const lStorage = JSON.parse(localStorage.getItem("login"));
  const userId = lStorage?.user?.userId;
  const userToken = lStorage?.token;

  const [rcsTemplateList, setRcsTemplateList] = useState([]);
  const [DialogOpen, setDialogOpen] = useState(false)
  const [rcsOnboardingList, setRcsOnboardingList] = useState([]);
  const [error, setError] = useState({
    status: false,
    errormessage: "",
    bgcolor: ""
  })
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [templateId, setTemplateId] = useState("")

  useEffect(() => {
    const getRcsTemplate = async () => {
      try {
        let paylod = {
          user_id: userId,
          token: userToken,
          method: "retrieve_temp",
        };
        let { data } = await RCSAPI(paylod);
        if (data.success) {
          setRcsTemplateList(data.data);
        }
        else {
          setError({
            status: true,
            errormessage: error.errormessage,
            bgcolor: "alert alert-danger"
          })
        }
      } catch (error) {
        setError({
          status: true,
          errormessage: error.errormessage,
          bgcolor: "alert alert-danger"
        })
      }
    };
    getRcsTemplate();
    fetchList();
  }, []);

  const fetchList = async () => {
    const payload = {
      user_id: userId,
      token: userToken,
      method: "onboarding_retrieve",

    }
    try {
      const response = await Axios.post(`${NODE_HOST_URL}/rcs`, payload)
      if (response.data.success) {
        setRcsOnboardingList(response.data.data);
        showDialog(response.data.data)
      }

    } catch (error) {
      console.log(error)

    }
  }

  const showDialog = (data) => {
    if (data.length === 0) {
      setDialogOpen(true);
      return;
    }

    const hasInvalidStatus = data.some((x) => x?.status !== 0);

    if (hasInvalidStatus) {
      setDialogOpen(false);
    } else {
      setDialogOpen(true);
    }
  };


  const handleClick = () => {
    handleUserLog("", "apply_button", "rcs", "User click on Apply button", "rcs_template_list", "", "");
    history.push('/dashboard/apply-rcs');
  };

  const DeleteTemplatePopup = (id) => {
    setIsDialogOpen(true)
    setTemplateId(id)
  }

  const DeleteTemplate = async () => {
    let paramData = {
      user_id: userId,
      token: userToken,
      method: "delete_temp",
      temp_id: templateId
    }
    try {
      let { data } = await Axios.post(`${NODE_HOST_URL}/rcs`, paramData)
      if (data.success) {
        setError({
          status: true,
          errormessage: data.message,
          bgcolor: "alert alert-success"
        })
        handleUserLog("", "rcs_template_deleted", "rcs", data.message, "rcs_template_list", "", { temp_id: templateId })
        fetchList();
      }
      else {
        setError({
          status: true,
          errormessage: data.message,
          bgcolor: "alert alert-danger"
        })
        handleUserLog("", "rcs_template_deleted", "rcs", data.message, "rcs_template_list", "", { temp_id: templateId })
      }
    } catch (error) {
      setError({
        status: true,
        errormessage: error.message,
        bgcolor: "alert alert-danger"
      })
      handleUserLog("", "rcs_template_deleted", "rcs", error.message, "rcs_template_list", "", { temp_id: templateId })
    }
    finally {
      setIsDialogOpen(false);
      setTimeout(() => {
        setError({ status: false });
      })
    }
  }

  return (
    <DashboardLayout>
      <main className="content">
        <div className="container-fluid p-0">
          <div className="row mb-2 mb-xl-3">
            <div className="col-auto d-none d-sm-block">
              <h3>
                <strong>RCS </strong> Template List{" "}
              </h3>
            </div>
            <div className="col-auto ml-auto text-right mt-n1">
              <Link
                className="btn btn-primary btn-sm"
                to="/dashboard/create-rcs-template"
                onClick={() => handleUserLog("", " clicked_add_rcs_template_button", "rcs", "User click on Add New RCS Template button", "rcs_template_list", "", "")}
              >
                {" "}
                <FontAwesomeIcon icon={faPlus} color="" /> Add New RCS Template{" "}
              </Link>
            </div>
          </div>
          {
            error.status ?
              <div className={error.bgcolor} role="alert">
                <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <div className="">
                  {error.errormessage}
                </div>
              </div>
              :
              null
          }
          <div className="row">
            <div className="">
              <div className="">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <h5 className="card-title mb-0">Rcs Template List </h5>
                      </div>
                      <hr className="m-0" />
                      <div className="">

                        {DialogOpen &&
                          <Dialog
                            modal={true}
                            open={DialogOpen}
                            onClose={() => setDialogOpen(false)}
                            maxWidth={"md"}
                          >
                            <div className="popup-overlay">
                              <div className="popup-container container">
                                <div className="col-md-12 row">
                                  {/* Left Column */}
                                  {rcsOnboardingList.find(x => x.status === 0) ? <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
                                    <h2 className="mb-2">Your WhatsApp Onboarding is Pending</h2>
                                    <p>Complete your onboarding now and start creating powerful RCS for your business.</p>
                                    {/* <p className="mb-2">Click here to create WhatsApp Widget.</p> */}
                                    {/* <Link to="/dashboard/whatsapp-widget" className="btn btn-primary">
                                                  Create Now
                                                </Link> */}

                                  </div> :
                                    <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-start">
                                      <h2 className="mb-2">You have not Applied for onboarding</h2>
                                      <p>Complete your onboarding now and start creating powerful RCS for your business.
                                        For RCS onboarding Click the apply button giving below
                                      </p>
                                      {/* <p className="mb-2">Click here to create WhatsApp Widget.</p> */}
                                      {/* <Link to="/dashboard/whatsapp-widget" className="btn btn-primary">
                                                Create Now
                                              </Link> */}

                                    </div>}

                                  {/* Right Column */}
                                  <div className="col-12 col-md-6 p-0">
                                    <img
                                      src={rcsimage}
                                      alt="RCS Widget Illustration"
                                      className="img-fluid w-100 h-100 object-fit-cover"
                                    />
                                  </div>
                                </div>

                                {rcsOnboardingList.length === 0 &&
                                  <div className="row">
                                    <div className="col-6"></div>
                                    <div className="col-6">
                                      <button type="button" onClick={handleClick} className="btn btn-primary float-right">Apply</button>
                                    </div>
                                  </div>}
                              </div>
                            </div>
                          </Dialog>}

                        {rcsTemplateList ? (
                          <div className="table-responsive">
                            <table className="table table-hover  project  my-0">
                              <thead>
                                <tr>
                                  <th>Template Name</th>
                                  <th>Template Category</th>
                                  <th>Sender Id</th>
                                  <th>Sender Name</th>
                                  <th>Template Type</th>
                                  <th>Created Date</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {rcsTemplateList.map((item, i) => (
                                  <tr key={i}>
                                    <td>{item.temp_name}</td>
                                    <td>{item.temp_category}</td>
                                    <td>{item.sender_id}</td>
                                    <td>{item.sender_name}</td>
                                    <td>{item.temp_type}</td>
                                    <td>{item.created}</td>
                                    <td>
                                      {item.temp_status === 0 ? (
                                        <span className="badge badge-primary">
                                          {" "}
                                          Pending{" "}
                                        </span>
                                      ) : item.temp_status === 1 ? (
                                        <span className="badge bg-success">
                                          {" "}
                                          Approved{" "}
                                        </span>
                                      ) : item.temp_status === 2 ? (
                                        <span className="badge badge-secondary">
                                          {" "}
                                          Draft{" "}
                                        </span>
                                      ) : item.temp_status === 5 ? (
                                        <span className="badge badge-info">
                                          {" "}
                                          In Review{" "}
                                        </span>
                                      ) : (
                                        <span className="badge badge-danger">
                                          {" "}
                                          Rejected{" "}
                                        </span>
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      <a
                                        href={`/dashboard/create-rcs-template/view/${item._id}`}
                                        onClick={() => handleUserLog("", "view_template_button", "rcs", "User click on view template button", "rcs_template_list", "", { id: item._id })}
                                      >
                                        <span className="badge bg-primary mr-2">
                                          {" "}
                                          View{" "}
                                        </span>{" "}
                                      </a>
                                      {/* {item.temp_status === 0 &&
                                        <>
                                          <a
                                            href={`/dashboard/create-rcs-template/edit/${item._id}`}
                                          >
                                            <span className="badge bg-info">
                                              {" "}
                                              Edit{" "}
                                            </span>{" "}
                                          </a>{" "}
                                          <span className="badge bg-danger ml-2" onClick={() => DeleteTemplatePopup(item._id)}>{" "}Delete{" "}</span>
                                        </>
                                      } */}

                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="text-center">
                            <div className="card-body">
                              <p>No Recod Found....</p>
                            </div>
                          </div>
                        )}

                        {
                          isDialogOpen &&
                          <Dialog
                            title={'Alert'}
                            modal={true}
                            height={500}
                            isDraggable={true}
                            onClose={() => setIsDialogOpen(false)}
                            buttons={
                              [{
                                text: "No",
                                className: 'btn-info btn-sm btn mr-2',
                                onClick: () => setIsDialogOpen(false)
                              },
                              {
                                text: "Yes",
                                className: 'btn-danger btn-sm btn mr-2',
                                onClick: () => DeleteTemplate()
                              },
                              ]
                            }>
                            <p> Are you sure want to delete this template </p>
                          </Dialog>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </DashboardLayout>
  );
};
export default RcsTemplateList;
